import React from 'react';
import { Box, Tab, Tabs, IconButton, Badge, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from '@mui/icons-material/Dashboard';

const ContentTabs = ({
  activeTab,
  openDashboards,
  onTabChange,
  onCloseDashboard,
  colors,
  unreadChatMessages = 0,
}) => {
  const handleChange = (event, newValue) => {
    onTabChange(newValue);
  };

  const handleCloseClick = (event, dashboardId) => {
    event.stopPropagation();
    onCloseDashboard(dashboardId);
  };

  // Don't render tabs if no dashboards are open
  if (openDashboards.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${colors.border}`,
        bgcolor: colors.surface,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 42,
          flexGrow: 1,
          '& .MuiTabs-indicator': {
            bgcolor: '#22c55e',
          },
          '& .MuiTab-root': {
            minHeight: 42,
            textTransform: 'none',
            color: colors.textSecondary,
            fontSize: '0.875rem',
            '&.Mui-selected': {
              color: '#22c55e',
            },
          },
        }}
      >
        {/* Chat tab - always first */}
        <Tab
          value="chat"
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Badge
                badgeContent={unreadChatMessages}
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: '0.65rem',
                    minWidth: 16,
                    height: 16,
                  },
                }}
              >
                <Box
                  component="img"
                  src="/img/atom-icon.svg"
                  alt="Atom"
                  sx={{ width: 18, height: 18 }}
                />
              </Badge>
              <span>Ask Atom</span>
            </Box>
          }
          sx={{
            minWidth: 100,
          }}
        />

        {/* Dashboard tabs */}
        {openDashboards.map((dashboard) => (
          <Tab
            key={dashboard.dashboardId}
            value={dashboard.dashboardId}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DashboardIcon sx={{ fontSize: 18 }} />
                <span>{dashboard.title}</span>
                <Tooltip title="Close dashboard">
                  <IconButton
                    size="small"
                    onClick={(e) => handleCloseClick(e, dashboard.dashboardId)}
                    sx={{
                      p: 0.25,
                      ml: 0.5,
                      color: colors.textMuted,
                      '&:hover': {
                        color: '#ef4444',
                        bgcolor: 'rgba(239, 68, 68, 0.1)',
                      },
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
              </Box>
            }
            sx={{
              minWidth: 140,
              maxWidth: 200,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default ContentTabs;
